<script>
  export let additionalClass;
  export let favouriteClick;
</script>

<svg
  on:click={favouriteClick}
  xmlns="http://www.w3.org/2000/svg"
  class={`h-6 w-6 ${additionalClass}`}
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M9 5l7 7-7 7"
  />
</svg>
